function UpcomingBookingEmpty() {

    return (

        <div style={styles.empty}>

            <h2 style={styles.title}>
                No Upcoming Bookings
            </h2>

            <p style={styles.text}>
                Book your first court to get started.
            </p>

        </div>
    );
}

const styles = {

    empty: {

        background:
            "rgba(0,40,70,0.72)",

        borderRadius: "24px",

        padding: "60px 30px",

        textAlign: "center",
    },

    title: {

        color: "#fff",
    },

    text: {

        color: "#cbd5e1",
    },
};

export default UpcomingBookingEmpty;